export default __webpack_public_path__ + "static/media/Netlify.3bb188f4.md";